module.exports = {
	"_args": [
		[
			"babel-core@https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "babel-core@>=5.7.3 <6.0.0",
	"_id": "babel-core@5.8.35",
	"_inCache": true,
	"_location": "/babel-core",
	"_phantomChildren": {},
	"_requested": {
		"name": "babel-core",
		"raw": "babel-core@https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
		"rawSpec": "https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/",
		"/babel-eslint",
		"/babel-loader",
		"/jscodeshift"
	],
	"_resolved": "https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
	"_shasum": "9d27c5f7199a400cc426ce1f6fac149065ea14bf",
	"_shrinkwrap": null,
	"_spec": "babel-core@https://registry.npmjs.org/babel-core/-/babel-core-5.8.35.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"browser": {
		"./lib/api/register/node.js": "./lib/api/register/browser.js"
	},
	"bugs": {
		"url": "https://github.com/babel/babel/issues"
	},
	"dependencies": {
		"babel-plugin-constant-folding": "^1.0.1",
		"babel-plugin-dead-code-elimination": "^1.0.2",
		"babel-plugin-eval": "^1.0.1",
		"babel-plugin-inline-environment-variables": "^1.0.1",
		"babel-plugin-jscript": "^1.0.4",
		"babel-plugin-member-expression-literals": "^1.0.1",
		"babel-plugin-property-literals": "^1.0.1",
		"babel-plugin-proto-to-assign": "^1.0.3",
		"babel-plugin-react-constant-elements": "^1.0.3",
		"babel-plugin-react-display-name": "^1.0.3",
		"babel-plugin-remove-console": "^1.0.1",
		"babel-plugin-remove-debugger": "^1.0.1",
		"babel-plugin-runtime": "^1.0.7",
		"babel-plugin-undeclared-variables-check": "^1.0.2",
		"babel-plugin-undefined-to-void": "^1.1.6",
		"babylon": "^5.8.35",
		"bluebird": "^2.9.33",
		"chalk": "^1.0.0",
		"convert-source-map": "^1.1.0",
		"core-js": "^1.0.0",
		"debug": "^2.1.1",
		"detect-indent": "^3.0.0",
		"esutils": "^2.0.0",
		"fs-readdir-recursive": "^0.1.0",
		"globals": "^6.4.0",
		"home-or-tmp": "^1.0.0",
		"is-integer": "^1.0.4",
		"js-tokens": "1.0.1",
		"json5": "^0.4.0",
		"line-numbers": "0.2.0",
		"lodash": "^3.10.0",
		"minimatch": "^2.0.3",
		"output-file-sync": "^1.1.0",
		"path-exists": "^1.0.0",
		"path-is-absolute": "^1.0.0",
		"private": "^0.1.6",
		"regenerator": "0.8.40",
		"regexpu": "^1.3.0",
		"repeating": "^1.1.2",
		"resolve": "^1.1.6",
		"shebang-regex": "^1.0.0",
		"slash": "^1.0.0",
		"source-map": "^0.5.0",
		"source-map-support": "^0.2.10",
		"to-fast-properties": "^1.0.0",
		"trim-right": "^1.0.0",
		"try-resolve": "^1.0.0"
	},
	"description": "A compiler for writing next generation JavaScript",
	"devDependencies": {},
	"homepage": "https://babeljs.io/",
	"keywords": [
		"6to5",
		"babel",
		"classes",
		"const",
		"es6",
		"harmony",
		"let",
		"modules",
		"transpile",
		"transpiler",
		"var"
	],
	"license": "MIT",
	"name": "babel-core",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/babel/babel.git"
	},
	"scripts": {
		"bench": "make bench",
		"test": "make test"
	},
	"version": "5.8.35"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/package.json
 ** module id = ./node_modules/babel-core/package.json
 ** module chunks = 0
 **/